/**
 * SquadsScreen — Squads (templates reutilizáveis). Bloco 6.
 *
 * Grade de templates salvos (GET /squad-templates) + "Novo template" (POST).
 * "Usar" incrementa runs e leva à Jornada. Substitui o placeholder de /workflows.
 */
import { C } from '@/theme/palette';
import { useState } from 'react';
import { useNavigationContext } from '@/navigation';
import { useSquadTemplates, useCreateSquadTemplate, useUseSquadTemplate } from '@/api/squadTemplates';

// Paleta: segue o tema global (aliases bg/surface/border/text/dim/muted… em theme/palette.js).

export function SquadsScreen() {
  const { navigate } = useNavigationContext();
  const { data, isLoading } = useSquadTemplates();
  const create = useCreateSquadTemplate();
  const useTpl = useUseSquadTemplate();
  const [form, setForm] = useState({ name: '', mission: '', agent_count: 6 });
  const [showForm, setShowForm] = useState(false);

  const items = data?.items ?? [];

  const submit = () => {
    if (!form.name.trim()) return;
    create.mutate({ ...form, agent_count: Number(form.agent_count) || 0 }, {
      onSuccess: () => { setForm({ name: '', mission: '', agent_count: 6 }); setShowForm(false); },
    });
  };

  return (
    <div className="sp-page" style={{ color: C.text }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
        <h2 style={{ margin: 0, fontSize: 22, letterSpacing: '-0.02em' }}>Squads · Templates</h2>
        <button onClick={() => setShowForm(!showForm)}
          style={{ marginLeft: 'auto', cursor: 'pointer', background: C.accent, color: C.black,
            border: 'none', borderRadius: 8, padding: '9px 16px', fontSize: 13, fontWeight: 700 }}>
          {showForm ? '× Cancelar' : '+ Novo template'}
        </button>
      </div>
      <p style={{ color: C.dim, maxWidth: '70ch', marginTop: 10, fontSize: 13.5 }}>
        Templates de squads salvos e reutilizáveis. "Usar" registra o uso e inicia a Jornada.
      </p>

      {showForm && (
        <div style={{ marginTop: 16, border: `1px solid ${C.border}`, background: C.surface, borderRadius: 12, padding: 16 }}>
          <input placeholder="Nome do template" value={form.name}
            onChange={(e) => setForm({ ...form, name: e.target.value })}
            style={{ width: '100%', background: C.surface2, color: C.text, border: `1px solid ${C.border}`,
              borderRadius: 8, padding: 10, fontSize: 13, marginBottom: 10 }} />
          <input placeholder="Missão" value={form.mission}
            onChange={(e) => setForm({ ...form, mission: e.target.value })}
            style={{ width: '100%', background: C.surface2, color: C.text, border: `1px solid ${C.border}`,
              borderRadius: 8, padding: 10, fontSize: 13, marginBottom: 10 }} />
          <input type="number" placeholder="Nº de agentes" value={form.agent_count} min={0}
            onChange={(e) => setForm({ ...form, agent_count: e.target.value })}
            style={{ width: 160, background: C.surface2, color: C.text, border: `1px solid ${C.border}`,
              borderRadius: 8, padding: 10, fontSize: 13, marginRight: 10 }} />
          <button onClick={submit} disabled={create.isPending || !form.name.trim()}
            style={{ background: C.accent, color: C.black, border: 'none', borderRadius: 8,
              padding: '9px 16px', fontSize: 13, fontWeight: 700, cursor: 'pointer' }}>
            {create.isPending ? 'Salvando…' : 'Salvar template'}
          </button>
        </div>
      )}

      {isLoading && <div style={{ marginTop: 20, color: C.dim }}>Carregando…</div>}
      {!isLoading && items.length === 0 && !showForm && (
        <div style={{ marginTop: 24, padding: 28, border: `1px dashed ${C.border}`, borderRadius: 12,
          color: C.dim, textAlign: 'center' }}>
          Nenhum template salvo. Clique em <strong style={{ color: C.text }}>+ Novo template</strong>.
        </div>
      )}

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
        gap: 14, marginTop: 18 }}>
        {items.map((t) => (
          <div key={t.id} style={{ border: `1px solid ${C.border}`, background: C.surface, borderRadius: 14,
            padding: 18, borderTop: `2px solid ${C.neon}` }}>
            <div style={{ fontWeight: 700, fontSize: 15 }}>{t.name}</div>
            {t.mission && <p style={{ color: C.dim, fontSize: 12.5, margin: '8px 0 0' }}>{t.mission}</p>}
            <div style={{ display: 'flex', gap: 8, marginTop: 12, alignItems: 'center' }}>
              <span style={{ fontFamily: 'monospace', fontSize: 10.5, padding: '2px 8px', borderRadius: 6,
                background: C.surface2, color: C.dim }}>{t.agentCount} agentes</span>
              <span style={{ fontFamily: 'monospace', fontSize: 10.5, padding: '2px 8px', borderRadius: 6,
                background: C.surface2, color: C.muted }}>{t.runs} usos</span>
              <button onClick={() => useTpl.mutate(t.id, { onSuccess: () => navigate('/project') })}
                style={{ marginLeft: 'auto', background: 'transparent', color: C.accent,
                  border: `1px solid ${C.accent}`, borderRadius: 7, padding: '5px 12px', fontSize: 12, cursor: 'pointer' }}>
                Usar
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
